import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { getPatientFindingsSection, usePatientCase } from "../usePatientCase";
import { useDataInputPanels } from "../useDataInputPanels";
import { KahunPanels, Relations, Values } from "shared";

export const useGetPanelAbnormalQf = (
  section: PatientCaseGrouping,
  panelId: KahunPanels,
) => {
  const { patientCase } = usePatientCase();
  const qfs = getPatientFindingsSection(section, patientCase).filter(
    (qf) => !qf.skip,
  );

  const { panels } = useDataInputPanels();
  const panel = panels.get(panelId);
  const filteredQf = qfs.filter((qf) =>
    panel?.findings.find((finding) => finding.id === qf.feature.id),
  );

  const abnormalQf = filteredQf.filter((qf) =>
    qf.qualifiers.some(
      (qualifier) =>
        qualifier.relation.id === Relations.LEVEL &&
        qualifier.value.id !== Values.NORMAL,
    ),
  );

  let isAllNormal = true;

  if (filteredQf.length < panel?.findings.length) {
    isAllNormal = false;
  } else if (
    filteredQf.some((qf) =>
      qf.qualifiers.some(
        (qualifier) =>
          qualifier.relation.id === Relations.LEVEL &&
          qualifier.value.id !== Values.NORMAL,
      ),
    )
  ) {
    isAllNormal = false;
  }
  return {
    abnormalQf,
    isAllNormal,
    isAllCheck: filteredQf.length === panel?.findings.length,
  };
};
